import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SigninDto } from "./Signin.Dto";
import { AutenticacaoModule } from "src/Contexto/auth";
import { MapearErrosServidor } from "src/hook/Functions";
import { showToast } from "src/componentes";
import { UsuarioEnviarConfirmacaoEmail } from "src/services/Identity.Service";

const SiginInCode = () => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const { signIn } = AutenticacaoModule();
  const navigate = useNavigate();

  const onClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const onSubmit = async (data: SigninDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    setLoadingMessage("Criando seu cadastro...");

    try {
      const response = await signIn(data);
      if (response.success) {
        setLoadingMessage("Enviando e-mail de confirmação...");
        try {
          const emailRes = await UsuarioEnviarConfirmacaoEmail({
            email: data.email,
          } as any);
          if (emailRes.success) {
            showToast({
              message: "E-mail de confirmação enviado, verifique seu e-mail!",
              variant: "Info",
            });
          } else {
            showToast({
              message:
                emailRes.notifications?.[0]?.message ||
                "Não foi possível enviar o e-mail de confirmação.",
              title: "Aviso",
              variant: "Warning",
            });
          }
        } catch (err) {
          console.error("Erro ao enviar e-mail de ativação:", err);
          showToast({
            message:
              "Cadastro realizado com sucesso, mas não conseguimos enviar o e-mail de ativação. Você pode reenviá-lo na próxima página.",
            title: "Aviso",
            variant: "Warning",
          });
        }
        navigate("/confirmar-email", { state: { email: data.email } });
      } else {
        MapearErrosServidor(response.notifications, showToast);
      }
    } catch (error) {
      console.error("Erro ao realizar cadastro:", error);
      showToast({
        message: "Ocorreu um erro ao realizar o cadastro.",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };

  return {
    onSubmit,
    loading,
    loadingMessage,
    onClickNavigate,
  };
};
export default SiginInCode;
